// DOM scaffold — creates the empty mount nodes the app expects.
// This is its OWN module so it can be imported (and therefore executed)
// BEFORE ./app/index.js. ES module imports are hoisted and run in order,
// so importing this before the app guarantees the nodes exist when the
// app's top-level code (renderEffects(), etc.) runs.
//
// Original index.html had these four nodes in <body>:
//   <div class="bg-base"></div>
//   <div class="fx-wrapper" id="fxWrapper"></div>
//   <div id="app"></div>
//   <div id="chatRoot"></div>

function ensureScaffold() {
  const need = [
    { tag: 'div', cls: 'bg-base' },
    { tag: 'div', cls: 'fx-wrapper', id: 'fxWrapper' },
    { tag: 'div', id: 'app' },
    { tag: 'div', id: 'chatRoot' },
  ];
  for (const n of need) {
    if (n.id && document.getElementById(n.id)) continue;
    if (!n.id && document.querySelector('.' + n.cls)) continue;
    const el = document.createElement(n.tag);
    if (n.cls) el.className = n.cls;
    if (n.id) el.id = n.id;
    document.body.appendChild(el);
  }
}

// document.body is guaranteed to exist here because index.html loads
// /src/main.js as type="module", which is deferred until after the DOM
// is parsed. But we guard anyway for safety.
if (document.body) {
  ensureScaffold();
} else {
  document.addEventListener('DOMContentLoaded', ensureScaffold);
}
